import { CtaButtonSlice } from '@monofront/slice-machine/prismicio-types';
import { CtaButton as CtaButtonBase } from '@slices/CtaButton';

export const CtaButton = ({
  prismicContent,
}: {
  prismicContent: CtaButtonSlice;
}) => {
  return <CtaButtonBase {...prismicContent} />;
};
